export default {"src":"/_next/static/image/public/images/ic_return_policy_vertical_menu.eee3b1d0921027d4da1a3822874d682b.svg","height":20,"width":20};